// ✅ src/services/locationService.js
import axiosClient from "../api/axiosClient";

// locations by tenant
export const getLocationsByTenant = async (tenant_id) => {
  const { data } = await axiosClient.get("/tenant/api/locations/list", {
    params: { tenant_id },
  });
  return data; // { success, data: [ {id,name,...}, ... ] }
};
